{
  "labels": {
    "paste": "Yapıştır",
    "pasteAsPlaintext": "Düz metin olarak yapıştır",
    "pasteCharts": "Grafikleri yapıştır",
    "selectAll": "Tümünü seç",
    "multiSelect": "Seçime öge ekle",
    "moveCanvas": "Tuvali taşı",
    "cut": "Kes",
    "copy": "Kopyala",
    "copyAsPng": "Panoya PNG olarak kopyala",
    "copyAsSvg": "Panoya SVG olarak kopyala",
    "copyText": "Panoya metin olarak kopyala",
    "copySource": "Kaynağı panoya kopyala",
    "convertToCode": "Koda dönüştür",
    "bringForward": "Bir öne getir",
    "sendToBack": "Arkaya gönder",
    "bringToFront": "En öne getir",
    "sendBackward": "Bir geriye gönder",
    "delete": "Sil",
    "copyStyles": "Stilleri kopyala",
    "pasteStyles": "Stilleri yapıştır",
    "stroke": "Kontur",
    "changeStroke": "Kontur rengini değiştir",
    "background": "Arka plan",
    "changeBackground": "Arka plan rengini değiştir",
    "fill": "Doldur",
    "strokeWidth": "Kontur genişliği",
    "strokeStyle": "Kontur stili",
    "strokeStyle_solid": "Dolu",
    "strokeStyle_dashed": "Kesik çizgili",
    "strokeStyle_dotted": "Noktalı",
    "sloppiness": "Üstün körülük",
    "opacity": "Opaklık",
    "textAlign": "Metin hizala",
    "edges": "Kenarlar",
    "sharp": "Keskin",
    "round": "Yuvarlak",
    "arrowheads": "Ok uçları",
    "arrowhead_none": "Yok",
    "arrowhead_arrow": "Ok",
    "arrowhead_bar": "Çizgi",
    "arrowhead_circle": "Çember",
    "arrowhead_circle_outline": "Çember (anahat)",
    "arrowhead_triangle": "Üçgen",
    "arrowhead_triangle_outline": "Üçgen (anahat)",
    "arrowhead_diamond": "Elmas",
    "arrowhead_diamond_outline": "Elmas (anahat)",
    "arrowhead_crowfoot_many": "Karga ayak (çok)",
    "arrowhead_crowfoot_one": "Karga ayak (bir)",
    "arrowhead_crowfoot_one_or_many": "Karga ayak (bir veya çok sayıda)",
    "more_options": "Daha fazla seçenek",
    "arrowtypes": "Ok şekli",
    "arrowtype_sharp": "Düz ok",
    "arrowtype_round": "Kavisli ok",
    "arrowtype_elbowed": "Köşeli ok",
    "fontSize": "Yazı tipi boyutu",
    "fontFamily": "Yazı tipi ailesi",
    "addWatermark": "\"Excalidraw ile yapıldı\" yazısını ekle",
    "handDrawn": "El-yazısı",
    "normal": "Normal",
    "code": "Kod",
    "small": "Küçük",
    "medium": "Orta",
    "large": "Büyük",
    "veryLarge": "Çok büyük",
    "solid": "Dolu",
    "hachure": "Taralı",
    "zigzag": "Zikzak",
    "crossHatch": "Çapraz-taralı",
    "thin": "İnce",
    "bold": "Kalın",
    "left": "Sol",
    "center": "Ortala",
    "right": "Sağ",
    "extraBold": "Ekstra kalın",
    "architect": "Mimar",
    "artist": "Sanatçı",
    "cartoonist": "Karikatürist",
    "fileTitle": "Dosya adı",
    "colorPicker": "Renk seçicisi",
    "canvasColors": "Tuvalin üzerinde kullanıldı",
    "canvasBackground": "Tuval arka planı",
    "drawingCanvas": "Çizim tuvali",
    "clearCanvas": "Tuvali temizle",
    "layers": "Katmanlar",
    "actions": "Eylemler",
    "language": "Dil",
    "liveCollaboration": "Canlı ortak çalışma alanı...",
    "duplicateSelection": "Çoğalt",
    "untitled": "Adsız",
    "name": "Ad",
    "yourName": "Adınız",
    "madeWithExcalidraw": "Excalidraw ile yapıldı",
    "group": "Seçimi grup yap",
    "ungroup": "Seçilen grubu dağıt",
    "collaborators": "Ortaklar",
    "toggleGrid": "Izgarayı aç/kapat",
    "addToLibrary": "Kütüphaneye ekle",
    "removeFromLibrary": "Kütüphaneden kaldır",
    "libraryLoadingMessage": "Kütüphane yükleniyor…",
    "libraries": "Kütüphanelere gözat",
    "loadingScene": "Sahne yükleniyor…",
    "loadScene": "Dosyadan sahne yükle",
    "align": "Hizala",
    "alignTop": "Yukarı hizala",
    "alignBottom": "Aşağı hizala",
    "alignLeft": "Sola hizala",
    "alignRight": "Sağa hizala",
    "centerVertically": "Dikeyde ortala",
    "centerHorizontally": "Yatayda ortala",
    "distributeHorizontally": "Yatay dağıt",
    "distributeVertically": "Dikey dağıt",
    "flipHorizontal": "Yatay döndür",
    "flipVertical": "Dikey döndür",
    "viewMode": "Görünüm modu",
    "share": "Paylaş",
    "showStroke": "Kontur için renk seçiciyi göster",
    "showBackground": "Arka plan renk seçicisini göster",
    "showFonts": "Yazı tipi seçici",
    "toggleTheme": "Aydınlık/karanlık mod",
    "theme": "Tema",
    "personalLib": "Kişisel Kitaplık",
    "excalidrawLib": "Excalidraw Kitaplığı",
    "decreaseFontSize": "Yazı Tipi Boyutunu Küçült",
    "increaseFontSize": "Yazı Tipi Boyutunu Büyült",
    "unbindText": "Metni çöz",
    "bindText": "Metni taşıyıcıya bağla",
    "createContainerFromText": "Metni bileşen içinde sar",
    "link": {
      "edit": "Bağlantıyı düzenle",
      "editEmbed": "Gömülebilir bağlantıyı düzenle",
      "create": "Bağlantı ekle",
      "label": "Bağlantı",
      "labelEmbed": "Bağlantıla ve göm",
      "empty": "Herhangi bir bağlantı oluşturulmadı",
      "hint": "Bağlantınızı buraya yazın veya yapıştırın",
      "goToElement": "Hedef öğeye git"
    },
    "lineEditor": {
      "edit": "Çizgiyi düzenle",
      "editArrow": "Oku düzenle"
    },
    "polygon": {
      "breakPolygon": "Çokgeni kır",
      "convertToPolygon": "Çokgene dönüştür"
    },
    "elementLock": {
      "lock": "Kilitle",
      "unlock": "Kilidi Kaldır",
      "lockAll": "Hepsini kilitle",
      "unlockAll": "Hepsinin kilidini kaldır"
    },
    "statusPublished": "Yayınlandı",
    "sidebarLock": "Kenar çubuğu açık kalsın",
    "selectAllElementsInFrame": "Çerçevedeki tüm bileşenleri seç",
    "removeAllElementsFromFrame": "Çerçevedeki tüm bileşenleri sil",
    "eyeDropper": "Tuvalden renk seç",
    "textToDiagram": "Yazıdan diyagrama",
    "prompt": "İstem",
    "followUs": "Bizi takip edin",
    "discordChat": "Discord sohbeti",
    "zoomToFitViewport": "Görüş alanına sığdırmak için yakınlaştırın",
    "zoomToFitSelection": "Seçime sığdırmak için yakınlaştırın",
    "zoomToFit": "Tüm öğeleri sığdırmak için yakınlaştırın",
    "installPWA": "Excalidraw'ı yerel olarak yükle (PWA)",
    "autoResize": "Metni otomatik yeniden boyutlandırmayı etkinleştir",
    "imageCropping": "Görsel kırpma",
    "unCroppedDimension": "Kırpılmamış ölçüler",
    "copyElementLink": "Bağlantıyı nesneye kopyala",
    "linkToElement": "Nesneye bağlantıla",
    "wrapSelectionInFrame": "Seçimi karede kaydır",
    "tab": "Sekme",
    "shapeSwitch": "Şekli başkasıyla değiştir"
  },
  "elementLink": {
    "title": "Nesneye bağlantıla",
    "desc": "Tuvaldeki bir nesneye tıklayın veya bir bağlantıyı yapıştırın.",
    "notFound": "Bağlantılanan nesne tuvalde bulunamadı."
  },
  "library": {
    "noItems": "Öğe eklenmedi...",
    "hint_emptyLibrary": "Öğelerden birini eklemek için öğeyi seçin veya aşağıdaki genel kütüphaneden öğeleri ekleyin.",
    "hint_emptyPrivateLibrary": "Tuvalden bir eleman seçerek sayfaya ekleyin.",
    "search": {
      "inputPlaceholder": "Kütüphanede ara",
      "heading": "Kütüphane eşleşmeleri",
      "noResults": "Eşleşen öğe bulunamadı…",
      "clearSearch": "Aramayı temizle"
    }
  },
  "search": {
    "title": "Tuvalde bul",
    "noMatch": "Sonuç bulunamadı...",
    "singleResult": "sonuç",
    "multipleResults": "sonuç",
    "placeholder": "Tuvalde metin bul…",
    "frames": "Çerçeveler",
    "texts": "Metinler"
  },
  "buttons": {
    "clearReset": "Tuvali sıfırla",
    "exportJSON": "Dosyaya aktar",
    "exportImage": "Resimleri dışa aktar...",
    "export": "Şuraya kaydet...",
    "copyToClipboard": "Panoya kopyala",
    "copyLink": "Linki kopyala",
    "save": "Geçerli dosyaya kaydet",
    "saveAs": "Farklı kaydet",
    "load": "Aç",
    "getShareableLink": "Paylaşılabilir bağlantı al",
    "close": "Kapat",
    "selectLanguage": "Dil seçin",
    "scrollBackToContent": "İçeriğe geri dön",
    "zoomIn": "Yakınlaştır",
    "zoomOut": "Uzaklaştır",
    "resetZoom": "Yakınlaştırmayı sıfırla",
    "menu": "Menü",
    "done": "Tamam",
    "edit": "Düzenle",
    "undo": "Geri Al",
    "redo": "Yeniden yap",
    "resetLibrary": "Kütüphaneyi sıfırla",
    "createNewRoom": "Yeni oda oluştur",
    "fullScreen": "Tam ekran",
    "darkMode": "Koyu tema",
    "lightMode": "Açık tema",
    "systemMode": "Sistem modu",
    "zenMode": "Zen modu",
    "objectsSnapMode": "Nesnelere hizala",
    "exitZenMode": "Zen modundan çık",
    "cancel": "İptal",
    "saveLibNames": "Adları kaydet ve çık",
    "clear": "Temizle",
    "remove": "Kaldır",
    "embed": "Yerleştirmeyi aç veya kapa",
    "publishLibrary": "Yeniden adlandır veya yayımla",
    "submit": "Gönder",
    "confirm": "Onayla",
    "embeddableInteractionButton": "Etkileşime girmek için tıkla"
  },
  "alerts": {
    "clearReset": "Tuvalin tamamı temizlenecek. Emin misiniz?",
    "couldNotCreateShareableLink": "Paylaşılabilir bağlantı oluşturulamadı.",
    "couldNotCreateShareableLinkTooBig": "Paylaşılabilir bağlantı oluşturulamadı: sahne çok büyük",
    "couldNotLoadInvalidFile": "Bilinmeyen dosya yüklenemiyor",
    "importBackendFailed": "Sunucudan içe aktarma başarısız.",
    "cannotExportEmptyCanvas": "Boş tuval dışarıya aktarılamaz.",
    "couldNotCopyToClipboard": "Panoya kopyalanamıyor.",
    "decryptFailed": "Şifrelenmiş veri çözümlenemedi.",
    "uploadedSecurly": "Yükleme uçtan uca şifreleme ile korunmaktadır. Excalidraw sunucusu ve üçüncül şahıslar içeriği okuyamayacaktır.",
    "loadSceneOverridePrompt": "Harici çizimler yüklemek mevcut olan içeriği değiştirecektir. Devam etmek istiyor musunuz?",
    "collabStopOverridePrompt": "Oturumu sonlandırmak daha önceki, yerel olarak kaydedilmiş çizimin üzerine kaydedilmesine sebep olacak. Emin misiniz?\n\n(Yerel çiziminizi kaybetmemek için tarayıcı sekmesini kapatabilirsiniz.)",
    "errorAddingToLibrary": "Öğe kütüphaneye eklenemedi",
    "errorRemovingFromLibrary": "Öğe kütüphaneden silinemedi",
    "confirmAddLibrary": "Bu, kitaplığınıza {{numShapes}} tane şekil ekleyecek. Emin misiniz?",
    "imageDoesNotContainScene": "Bu görüntü herhangi bir sahne verisi içermiyor gibi görünüyor. Dışa aktarma sırasında sahne yerleştirmeyi etkinleştirdiniz mi?",
    "cannotRestoreFromImage": "Sahne bu resim dosyasından geri yüklenemedi",
    "invalidSceneUrl": "Verilen bağlantıdan çalışma alanı yüklenemedi. Dosya bozuk olabilir veya geçerli bir Excalidraw JSON verisi bulundurmuyor olabilir.",
    "resetLibrary": "Bu işlem kütüphanenizi sıfırlayacak. Emin misiniz?",
    "removeItemsFromsLibrary": "{{count}} öğe(ler) kitaplıktan kaldırılsın mı?",
    "invalidEncryptionKey": "Şifreleme anahtarı 22 karakter olmalı. Canlı işbirliği devre dışı bırakıldı.",
    "collabOfflineWarning": "İnternet bağlantısı bulunamadı. Değişiklikleriniz kaydedilmeyecek!",
    "localStorageQuotaExceeded": "Tarayıcı depolama kotası aşıldı. Değişiklikler kaydedilmeyecek."
  },
  "errors": {
    "unsupportedFileType": "Desteklenmeyen dosya türü.",
    "imageInsertError": "Görsel eklenemedi. Daha sonra tekrar deneyin...",
    "fileTooBig": "Dosya çok büyük. İzin verilen maksimum boyut {{maxSize}}.",
    "svgImageInsertError": "SVG resmi eklenemedi. SVG işaretlemesi geçersiz görünüyor.",
    "failedToFetchImage": "Görsel alınamadı.",
    "cannotResolveCollabServer": "İş birliği sunucusuna bağlanılamıyor. Lütfen sayfayı yenileyip tekrar deneyin.",
    "importLibraryError": "Kütüphane yüklenemedi",
    "saveLibraryError": "Kitaplık depolama alanına kaydedilemedi. Değişikliklerinizi kaybetmediğinizden emin olmak için lütfen kitaplığınızı yerel olarak bir dosyaya kaydedin.",
    "collabSaveFailed": "Backend veritabanına kaydedilemedi. Eğer problem devam ederse, çalışmanızı korumak için dosyayı yerel olarak kaydetmelisiniz.",
    "collabSaveFailed_sizeExceeded": "Arka uç veritabanına kaydedilemedi; tuval çok büyük. Çalışmanızı korumak için dosyayı yerel olarak kaydetmelisiniz.",
    "imageToolNotSupported": "Görseller devre dışı.",
    "brave_measure_text_error": {
      "line1": "Görünüşe göre Brave tarayıcısını <bold>Agresif Olarak Parmak İzini Engelle</bold> ayarı etkin olarak kullanıyorsunuz.",
      "line2": "Bu, çizimlerinizdeki <bold>Metin Öğelerinin</bold> kırılmasına neden olabilir.",
      "line3": "Bu ayarı devre dışı bırakmanızı şiddetle tavsiye ederiz. Bunu nasıl yapacağınızı öğrenmek için <link>bu adımları</link> takip edebilirsiniz.",
      "line4": "Bu ayarın devre dışı bırakılması metin öğelerinin görüntülenmesini düzeltmezse, lütfen GitHub'ımızda bir <issueLink>issue</issueLink> açın veya <discordLink>Discord</discordLink> adresinden bize yazın"
    },
    "libraryElementTypeError": {
      "embeddable": "Yerleştirilebilir ögeler bu kütüphaneye eklenemez.",
      "iframe": "IFrame öğeleri kütüphaneye eklenemez.",
      "image": "Resimleri kütüphaneye ekleme desteği yakında geliyor!"
    },
    "asyncPasteFailedOnRead": "Yapıştırılamadı (sistem panosundan okunamadı).",
    "asyncPasteFailedOnParse": "Yapıştırılamıyor.",
    "copyToSystemClipboardFailed": "Panoya kopyalanamıyor."
  },
  "toolBar": {
    "selection": "Seçme",
    "lasso": "Serbest seçim",
    "image": "Görsel ekle",
    "rectangle": "Dikdörtgen",
    "diamond": "Elmas",
    "ellipse": "Elips",
    "arrow": "Ok",
    "line": "Çizgi",
    "freedraw": "Çiz",
    "text": "Yazı",
    "library": "Kütüphane",
    "lock": "Seçilen aracı çizimden sonra aktif tut",
    "penMode": "Kalem modu - dokunmayı engelle",
    "link": "Seçilen şekil için bağlantı Ekle/Güncelle",
    "eraser": "Silgi",
    "frame": "Çerçeve aracı",
    "magicframe": "Wireframe'den koda",
    "embeddable": "Web Yerleştirme",
    "laser": "Lazer işaretçisi",
    "hand": "El (hareket aracı)",
    "extraTools": "Daha fazla araç",
    "mermaidToExcalidraw": "Mermaid'den Excalidraw'a",
    "convertElementType": "Şekil türünü aç/kapat"
  },
  "element": {
    "rectangle": "Dikdörtgen",
    "diamond": "Elmas",
    "ellipse": "Elips",
    "arrow": "Ok",
    "line": "Çizgi",
    "freedraw": "Serbest Çizim",
    "text": "Yazı",
    "image": "Görüntü",
    "group": "Grup",
    "frame": "Çerçeve",
    "magicframe": "Wireframe'den koda",
    "embeddable": "Web Yerleştirme",
    "selection": "Seçim",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Tuval eylemleri",
    "selectedShapeActions": "Seçilen şekil aksiyonları",
    "shapes": "Şekiller"
  },
  "hints": {
    "dismissSearch": "Aramayı kapatmak için {{shortcut}} kullanın",
    "canvasPanning": "Tuvali taşımak için {{shortcut_1}} kısayolunu basılı tutun, sürüklerken {{shortcut_2}} kısayolunu veya el aracını kullanın",
    "linearElement": "Birden fazla nokta için tıklayın, tek çizgi için sürükleyin",
    "arrowTool": "Birden çok nokta başlatmak için tıklayın, tek bir çizgi için sürükleyin. Ok türünü değiştirmek için {{shortcut}} kısayoluna basın.",
    "arrowBindModifiers": "",
    "freeDraw": "Tıkla ve sürükle, bitirdiğinde serbest bırak",
    "text": "İpucu: seçme aracıyla herhangi bir yere çift tıklayarak da yazı ekleyebilirsin",
    "embeddable": "Web sitesi yerleştirmek için sürükle bırak",
    "text_selected": "Metni düzenlemek için çift tıklayın veya {{shortcut}} kısayoluna basın",
    "text_editing": "Düzenlemeyi bitirmek için {{shortcut_1}} veya {{shortcut_2}} kısayoluna basın",
    "linearElementMulti": "Bitirmek için son noktaya tıklayın veya {{shortcut_1}} veya {{shortcut_2}} kısayolunu kullanın",
    "lockAngle": "{{shortcut}} kısayolunu basılı tutarak açıyı kısıtlayabilirsiniz",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "Kendi kitaplığınızı yayınlayın",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Bu özelliği etkinleştirmek muhtemelen \"dom.events.asyncClipboard.clipboardItem\" bayrağını \"true\" olarak ayarlayarak yapılabilir. Firefox'ta tarayıcı bayraklarını değiştirmek için \"about:config\" sayfasını ziyaret edin.",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Önizleme gösterilemiyor",
    "canvasTooBig": "Tuval pek büyük olabilir.",
    "canvasTooBigTip": "İpucu: En uzaktaki elemanları birbirine yakınlaştırmayı deneyin."
  },
  "errorSplash": {
    "headingMain": "Hata oluştu. Lütfen <button>sayfayı yenilemeyi deneyin.</button>",
    "clearCanvasMessage": "Yenileme sonrası sorun sürüyorsa lütfen <button>tuvali temizlemeyi</button> deneyin.",
    "clearCanvasCaveat": " Bu, yaptığınız değişiklikleri sıfırlayacak ",
    "trackedToSentry": "Tanımlayıcı ile ilgili hata {{eventId}} sistemimize yakalandı.",
    "openIssueMessage": "Sahne bilginizi hata mesajına yansıtmamak için oldukça dikkatli davrandık. Eğer sahneniz gizli değilse hatayı lütfen şuradan takip edin <button>hata takibi.</button> Lütfen aşağıya GitHub sorununa kopyalayarak ve yapıştırarak bilgi ekleyin.",
    "sceneContent": "Sahne içeriği:"
  },
  "shareDialog": {
    "or": "Veya"
  },
  "roomDialog": {
    "desc_intro": "İnsanları çiziminiz üzerinde birlikte çalışmaya davet edin.",
    "desc_privacy": "Endişelenmeyin, oturum uçtan uca şifrelenmiştir ve tamamen gizlidir. Ne çizdiğinizi sunucumuz bile göremez.",
    "button_startSession": "Oturumu başlat",
    "button_stopSession": "Oturumu sonlandır",
    "desc_inProgressIntro": "Ortak çalışma ortamı oluşturuldu.",
    "desc_shareLink": "Bu bağlantıyı birlikte çalışacağınız kişilerle paylaşabilirsiniz:",
    "desc_exitSession": "Çalışma ortamını kapattığınızda ortak çalışmadan ayrılmış olursunuz ancak kendi versiyonunuzda çalışmaya devam edebilirsiniz. Bu durumda ortak çalıştığınız diğer kişiler etkilenmeyecek, çalışma ortamındaki versiyon üzerinden çalışmaya devam edebilecekler.",
    "shareTitle": "Excalidraw'da canlı ortak calışma oturumuna katıl"
  },
  "errorDialog": {
    "title": "Hata"
  },
  "exportDialog": {
    "disk_title": "Belleğe kaydet",
    "disk_details": "Sahne verilerini daha sonra içe aktarabileceğiniz bir dosyaya aktarın.",
    "disk_button": "Dosyaya kaydet",
    "link_title": "Paylaşılabilir bağlantı",
    "link_details": "Salt okunur bir bağlantı olarak dışa aktarın.",
    "link_button": "Bağlantı olarak dışa aktar",
    "excalidrawplus_description": "Sahneyi Excalidraw+ çalışma alanınıza kaydedin.",
    "excalidrawplus_button": "Dışa aktar",
    "excalidrawplus_exportError": "Şu anda Excalidraw+'a aktarılamadı..."
  },
  "helpDialog": {
    "blog": "Blog'umuzu okuyun",
    "click": "tıkla",
    "deepSelect": "Derin seçim",
    "deepBoxSelect": "Kutu içerisinde derin seçim yapın, sürüklemeyi engelleyin",
    "createFlowchart": "Genel bir öğeden akış diyagramı oluşturun",
    "navigateFlowchart": "Bir akış diyagramında gezin",
    "curvedArrow": "Eğri ok",
    "curvedLine": "Eğri çizgi",
    "documentation": "Dokümantasyon",
    "doubleClick": "çift-tıklama",
    "drag": "sürükle",
    "editor": "Düzenleyici",
    "editLineArrowPoints": "Çizgi/ok noktalarını düzenle",
    "editText": "Etiket / metin düzenle",
    "github": "Bir hata mı buldun? Bildir",
    "howto": "Rehberlerimizi takip edin",
    "or": "veya",
    "preventBinding": "Ok bağlamayı önleyin",
    "tools": "Araçlar",
    "shortcuts": "Klavye kısayolları",
    "textFinish": "Düzenlemeyi bitir (metin düzenleyici)",
    "textNewLine": "Yeni satır ekle (metin düzenleyici)",
    "title": "Yardım",
    "view": "Görünüm",
    "zoomToFit": "Tüm öğeleri sığdırmak için yakınlaştır",
    "zoomToSelection": "Seçime yakınlaş",
    "toggleElementLock": "Seçimi Kilitle/çöz",
    "movePageUpDown": "Sayfayı yukarı/aşağı kaydır",
    "movePageLeftRight": "Sayfayı sola/sağa kaydır",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Tuvali temizle"
  },
  "publishDialog": {
    "title": "Kitaplığı yayınla",
    "itemName": "Öğe adı",
    "authorName": "Yazar adı",
    "githubUsername": "GıtHub kullanıcı adı",
    "twitterUsername": "Twitter kullanıcı adı",
    "libraryName": "Kitaplık adı",
    "libraryDesc": "Kitaplık açıklaması",
    "website": "Web sitesi",
    "placeholder": {
      "authorName": "Adınız ya da kullanıcı adınız",
      "libraryName": "Kitaplığınızın adı",
      "libraryDesc": "İnsanların kullanımını anlamasına yardımcı olmak için kitaplığınızın açıklaması",
      "githubHandle": "Github bağlantısı ( tercihe bağlı), kütüphane gözden geçirme için onaylandığında düzenleyebiliesiniz diye",
      "twitterHandle": "Twitter kullanıcı adı ( tercihe bağlı), bu sayede Twitter üzerinde paylaşıren çalışmanızı size atfedebiliriz",
      "website": "Kişisel web sayfanızı ya da başka bir yeri bağlayın (tercihe bağlı)"
    },
    "errors": {
      "required": "Gerekli",
      "website": "Geçerli bir URL girin"
    },
    "noteDescription": "Submit your library to be included in the <link>genel kütüphane reposu</link>diğer insanlar çizimlerinde kullanabilsin diye.",
    "noteGuidelines": "Önce kütüphane elle onaylanmalı. şunu okuyun <link>yönergeler</link> onaylamadan önce. gerekli olması halinde iletişim kurmak için ve değişiklik için Github hesabı gerekli, ama çok da illaki olmalı değil.",
    "noteLicense": "Bunu onaylayarak, kütüğhanenin şu lisansla yayınlanmasını onaylıyorsunuz <link>MIT Lisans, </link>ki bu kısaca herkesin onu kısıtlama olmaksızın kullanabileceği anlamına gelmektedir.",
    "noteItems": "Her kütüphane kendi ismine sahip olmalı ki tarama yapabilelim. Şu kütüphane ögeleri dahil edilecek:",
    "atleastOneLibItem": "Lütfen başlamak için en az bir tane kütüphane ögesi seçin",
    "republishWarning": "Not: seçilen ögelerden bir kısmı zaten yayınlanmış/gönderilmiş. Yalnızca mevcut kütüphane ve gönderileri güncellerken yeniden gönderme işlemi yapmalısınız."
  },
  "publishSuccessDialog": {
    "title": "Kütüphane gönderildi",
    "content": "Teşekkürler {{authorName}}. Kütüphaneniz gözden geçirme için alındı. Durumu takip edebilirsiniz<link>burada</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Kütüphaneyi sıfırla",
    "removeItemsFromLib": "Seçilen ögeleri kütüphaneden kaldır"
  },
  "imageExportDialog": {
    "header": "Resmi dışa aktar",
    "label": {
      "withBackground": "Arka plan",
      "onlySelected": "Sadece seçilen",
      "darkMode": "Karanlık mod",
      "embedScene": "Sahne yerleştir",
      "scale": "Ölçeklendir",
      "padding": "Dış boşluk"
    },
    "tooltip": {
      "embedScene": "Sahne verisi, sahnenin geri yüklenebilmesi için dışarı aktarılan PNG/SVG dosyasına kaydedilecektir. Bu, dışa aktarılan dosya boyutunu arttıracaktır."
    },
    "title": {
      "exportToPng": "PNG olarak dışa aktar",
      "exportToSvg": "SVG olarak dışa aktar",
      "copyPngToClipboard": "PNG'yi panoya kopyala"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Panoya kopyala"
    }
  },
  "encrypted": {
    "tooltip": "Çizimleriniz uçtan-uca şifrelenmiştir, Excalidraw'ın sunucuları bile onları göremez.",
    "link": "Excalidraw'da uçtan uca şifreleme hakkında blog yazısı"
  },
  "stats": {
    "angle": "Açı",
    "shapes": "Şekiller",
    "height": "Yükseklik",
    "scene": "Sahne",
    "selected": "Seçili",
    "storage": "Depolama",
    "fullTitle": "Tuval ve şekil özellikleri",
    "title": "Özellikler",
    "generalStats": "Genel",
    "elementProperties": "Şekil özellikleri",
    "total": "Toplam",
    "version": "Sürüm",
    "versionCopy": "Kopyalamak için tıkla",
    "versionNotAvailable": "Sürüm mevcut değil",
    "width": "Genişlik"
  },
  "toast": {
    "addedToLibrary": "Kütüphaneye eklendi",
    "copyStyles": "Stiller kopyalandı.",
    "copyToClipboard": "Panoya kopyalandı.",
    "copyToClipboardAsPng": "{{exportSelection}} panoya PNG olarak\n({{exportColorScheme}}) kopyalandı",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Dosya kaydedildi.",
    "fileSavedToFilename": "{filename} kaydedildi",
    "canvas": "tuval",
    "selection": "seçim",
    "pasteAsSingleElement": "Tekil obje olarak yapıştırmak için veya var olan bir metin editörüne yapıştırmak için {{shortcut}} kullanın",
    "unableToEmbed": "Bu URL'i yerleştirmeye şu anda izin verilmiyor. URL'in beyaz listeye alınmasını istiyorsanız GitHub'da bir issue açın",
    "unrecognizedLinkFormat": "Yerleştirdiğiniz bağlantı beklenen biçime uymuyor. Lütfen kaynak sitenin sağladığı \"yerleştir\" dizesini yapıştırmayı deneyin",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Şeffaf",
    "black": "Siyah",
    "white": "Beyaz",
    "red": "Kırmızı",
    "pink": "Pembe",
    "grape": "Koyu Mor",
    "violet": "Menekşe rengi",
    "gray": "Gri",
    "blue": "Mavi",
    "cyan": "Camgöbeği",
    "teal": "Deniz mavisi",
    "green": "Yeşil",
    "yellow": "Sarı",
    "orange": "Turuncu",
    "bronze": "Bronz"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Ecalidraw+'a mı gitmek istediniz?",
      "menuHint": "Dışa aktar, seçenekler, diller, ..."
    },
    "defaults": {
      "menuHint": "Dışa aktar, seçenekler, ve daha fazlası...",
      "center_heading": "Diyagramlar. Basitleştirildi.",
      "toolbarHint": "Bir araç seçin ve çizime başlayın!",
      "helpHint": "Kısayollar & yardım"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "En çok kullanılan özel renkler",
    "colors": "Renkler",
    "shades": "Tonlar",
    "hexCode": "Hex kodu",
    "noShades": "Bu renk için ton mevcut değil"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Görüntü olarak dışa aktar",
        "button": "Görüntü olarak dışa aktar",
        "description": "Sahne verilerini daha sonra içe aktarabileceğiniz bir görüntü olarak dışa aktarın."
      },
      "saveToDisk": {
        "title": "Diske kaydet",
        "button": "Diske Kaydet",
        "description": "Sahne verilerini daha sonra içe aktarabileceğiniz bir dosyaya aktarın."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Excalidraw+'a aktar",
        "description": "Sahneyi Excalidraw+ çalışma alanınıza kaydedin."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Dosyadan yükle",
        "button": "Dosyadan yükle",
        "description": "Bir dosyadan yükleme <bold>mevcut içeriğinizin yerini alacaktır</bold>.<br></br>Önce aşağıdaki seçeneklerden birini kullanarak çiziminizi yedekleyebilirsiniz."
      },
      "shareableLink": {
        "title": "Bağlantıdan yükle",
        "button": "İçeriğimi değiştir",
        "description": "Harici çizimin yüklenmesi <bold>mevcut içeriğinizin yerini alacaktır</bold>.<br></br>Önce aşağıdaki seçeneklerden birini kullanarak çiziminizi yedekleyebilirsiniz."
      }
    }
  },
  "mermaid": {
    "title": "Mermaid'den Excalidraw'a",
    "button": "Ekle",
    "description": "Şu anda yalnızca <flowchartLink>Akış şeması</flowchartLink>,<sequenceLink> Dizi, </sequenceLink> ve <classLink>Sınıf </classLink>Diyagramları deskteklenmektedir. Diğer türler, Excalidraw'da görsel olarak çizilecektir.",
    "syntax": "Mermaid Sözdizimi",
    "preview": "Önizleme",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": "Hızlı arama"
  },
  "fontList": {
    "badge": {
      "old": "eski"
    },
    "sceneFonts": "Bu sahnede",
    "availableFonts": "Kullanılabilir yazı tipleri",
    "empty": "Yazı tipi bulunamadı"
  },
  "userList": {
    "empty": "Kullanıcı bulunamadı",
    "hint": {
      "text": "Takip etmek için kullanıcıya tıklayın",
      "followStatus": "Şu anda bu kullanıcıyı takip ediyorsunuz",
      "inCall": "Kullanıcı bir sesli aramada",
      "micMuted": "Kullanıcının mikrofonu kapalı",
      "isSpeaking": "Kullanıcı konuşuyor"
    }
  },
  "commandPalette": {
    "title": "Komut paleti",
    "shortcuts": {
      "select": "Seç",
      "confirm": "Onayla",
      "close": "Kapat"
    },
    "recents": "Son kullanılan",
    "search": {
      "placeholder": "Menülerde, komutlarda arama yapın ve saklı kalmış hazineleri keşfedin",
      "noMatch": "Eşleşen komut yok..."
    },
    "itemNotAvailable": "Komut mevcut değil...",
    "shortcutHint": "Komut paleti için {{shortcut}} kullanın"
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
